import React from 'react';
import PropTypes from 'prop-types';
import RefundView from '../view/refund/component/RefundView';
import BaseModal from './BaseModal';

class RefundForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { transactionId, } = this.props;
    return (
      <BaseModal title={`Refund ${transactionId}`} buttonLbl="Refund">
        <RefundView requestedState={{ payItTransactionId: transactionId, }} />
      </BaseModal>
    );
  }
}

RefundForm.propTypes = {
  transactionId: PropTypes.string.isRequired,
};
export default RefundForm;
